import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	numProdDeployments: {
		id: 'software-deployment-frequency-report.deployment-frequency-bar-chart.chart.tooltip.num-prod-deployments',
		defaultMessage:
			'{numDeployments} production {numDeployments, plural, one {deployment} other {deployments}}',
		description: 'Display the number of deployments shipped on the selected week in the bar chart',
	},
	medianIssuesPerDeployments: {
		id: 'software-deployment-frequency-report.deployment-frequency-bar-chart.chart.tooltip.median-issues-per-deployments',
		defaultMessage:
			'{numIssues} median {numIssues, plural, one {issue} other {issues}} per deployment',
		description:
			'Display how many issues are shipped per deployment on the hovered week in the bar chart',
	},
	weekStartDate: {
		id: 'software-deployment-frequency-report.deployment-frequency-bar-chart.chart.tooltip.week-start-date',
		defaultMessage: 'Week of {date}',
		description: 'Display the start date of the hovered week in the bar chart',
	},
});
